export const LOGIN_TYPE = "cas";
// export const LOGIN_TYPE = "normal";

// react-route的Link
export const BASE_LINK = "/"; // 首页
export const DASHBOARD_LINK = "/dashboard"; // 工作台
export const SERVICE_LINK = "/s/index"; // service模块的link
export const CMSINFO_LINK = "/s/page"; // 单篇
export const CMSSECTION_LINK = "/s/list"; // 某个cms的消息列表
export const CONVERGE_APPLICATION_LINK = "/s/folder"; // 聚合应用
export const INTERNAL_LIST_LINK = "/internal"; // 内部应用
export const CMSINDEX_LINK = "/s/news"; // 新闻中心的LINK,包含所有的cms源
export const MY_GRADE_LINK = "/s/grade"; // 成绩查询页面

export const IFRAME_LINK = "/s/frame/link"; // 业务中心的iframe
export const MY_LINK = "/my/"; // 个人中心
export const TODO_LINK = "/todo/index"; // 个人中心

export const MAP_LINK = "/ext/map"; // 图片link
export const LOGIN_LINK = "/portal/login"; // 登陆页
export const ADMIN_LOGIN_LINK = "/admin/login"; // 登陆页
export const SIGNUP_LINK = "/portal/signup"; // 注册页
export const ADMIN_INDEX_LINK = "/admin/index"; // 管理端首页
export const ADMIN_INDEX_CONFIG_LINK = "/admin/indexConfig"; // 管理端首页

// 登陆的type
export const LOGIN_USER = "login_user";
export const LOGIN_SUCCESS = "login_success";
export const LOGIN_ERROR = "login_error";
export const LOG_OUT = "log_out";
export const LOG_OUT_ERROR = "log_out_error";
export const NO_SESSION = "no_session";

// 业务类的type
export const FETCH_SERVICE = "fetch_service";
export const SERVICE_CHOOSE = "service_choose";
export const CMS_SEARCH = "cms_search";
export const CMS_CLEAR = "cms_clear";

// Modal的type
export const ADD_SERVICE_GROUP = "add_service_group";
export const ADD_SERVICE = "add_service";
export const INIT_SERVICE = "init_service";

// 校务通知列表的type
export const SAVE_PAGE = "save_page";
export const CLEAR_PAGE = "clear_page";

// setting的type
export const NO_SETTING = "no_setting";
export const HAS_SETTING = "has_setting";
/*-----------------------------------------------------------------------------------------------*/

export const CAS_URL = `/auth/cas`;
//登陆类的url
export const LOGIN_URL = `/api/login`;
export const CHECK_URL = `/api/session`;
export const LOG_OUT_URL = `/api/logout`;

//业务类的url
export const FETCH_URL = `/api/services`;
export const CHOOSE_URL = `/api/service`;

//cms的url
export const CHANNELS_URL = `/api/channels`; //  获取新闻中心的source
export const RESOURCES_URL = `/api/channel`; //  source的详情
export const NEWS_URL = `/api/news`; // cms新闻内容api
export const CMS_CONTENT_URL = `/api/cms/content`; // 获取json格式的cms内容
export const FAVORITE_DEPT_NEWS = `/api/channel/favorite`; //订阅信息
export const REMOVE_FAVORITE_DEPT_NEWS = `/api/channel/removeFavorite`; //取消订阅
export const MY_FAVORITE_LIST_NEWS = `/api/my/channelList`; //获取我订阅的信息
//首页使用的url
// export const REPORT_URL = `/api/report`; //废弃
// export const WEBLIB_URL = `/api/app/weblibStatus`; //废弃
// export const LMS_URL = `/api/app/lmsStatus`; //废弃
export const INDEX_URL = `/api/index`;

//获取地图的url
export const MAP_SERVICE_LINK = "/api/app/map";

// 工作台的url
export const DASHBOARD_URL = `/api/dashboard`;
export const DASHBOARD_APP_URL = `/api/app/status`;
export const NEWS_COMBINE_URL = `/api/department/newsCombine`;
export const MY_FAV_NEWS_URL = `/api/my/channel`;

// 获取可订阅的信息
export const SUBSCRIBE_NEWS_URL = `/api/department/news`;
// 黄页
export const INTERNAL_DEPT_PHONE_URL = `/api/department/phone`;
// 组织架构
export const INTERNAL_DEPT_WEB_URL = `/api/department/web`;
// 获取个人信息
export const MY_INFO_URL = `/api/my/info`;
// 获取成绩
export const MY_GRADE_URL = `/api/my/grade`;
export const MY_LIB_URL = `/api/my/libRecord`;
// 获取OA
export const MY_OA_URL = `/api/my/oa`;
export const TODO_COUNT_URL = `/api/my/todoCount`;
export const CGZX_COUNT_URL = `/api/cgzx`;
// 获取大厅待办
export const INFO_PLUS_URL = '/api/infoPlus';

/*--------------------------------------------------------------------------------------------------------*/

// 首页配置模块的接口
export const SETUP_URL = `/api/setup`;
export const INDEX_SETUP_URL = `/api/admin/indexSettings`;
export const UPDATE_INDEX_SETUP_URL = `/api/admin/updateIndexSettings`;
export const REMOVE_INDEX_SETUP_URL = `/api/admin/removeIndexSettings`;
export const ACTIVE_INDEX_SETUP_URL = `/api/admin/activateIndexSetting`;
export const INIT_SETTING = `/dev/init`;

export const VALIDATE_BANNER_URL = `/api/admin/validateBannerLink`;
export const VALIDATE_SOURCE_URL = `/api/admin/validateSource`;

// export const SET_BANNER_URL = `/api/admin/indexBanner` // GET ?source=http://ccnl.scut.edu.cn/www/home_pic/index.xml
//http://211.66.86.105:4000/api/admin/stealBanner?source=http://ccnl.scut.edu.cn/www/home_pic/index.xml
// export const SET_INDEXSERVICES_URL = `/api/admin/indexServices`; // 设置首页service POST
// export const SET_INDEXSOURCES_URL = `/api/admin/indexSources`; // 设置首页source POST
export const VALID_SOURCES_URL = `/api/admin/validSources`; // 查看所有的source GET
export const VALID_SERVICES_URL = `/api/admin/validServices`; // 查看所有的service GET

// 应用管理模块
export const ADMIN_SERVICE_URL = `/api/admin/service`;
export const REMOVE_ADMIN_SERVICE_URL = `/api/admin/removeService`;
export const UPDATE_ADMIN_SERVICE_URL = `/api/admin/updateService`;

export const ADMIN_FOLDER_SERVICE_URL = `/api/admin/services`; //应用聚合类型的查询

export const SERVICE_GROUP_URL = `/api/admin/serviceGroup`; //POST 用于 service_group操作
export const REMOVE_SERVICE_GROUP_URL = `/api/admin/removeServiceGroup`; //delete 用于 service_group操作
export const UPDATE_SERVICE_GROUP_URL = `/api/admin/updateServiceGroup`; //update 用于 service_group操作

export const SORT_SERVICE_GROUP_URL = `/api/admin/sortServiceGroups`; //用于 排序service_group操作
export const SORT_SERVICE_URL = `/api/admin/reorderServices`; //用于 排序group中的应用
export const SERVICE_INGROUP_URL = `/api/admin/serviceInGroup`; //POST 用于 service_group操作
export const VALID_SERVICES_FOR_FOLDER_URL = `/api/admin/validServicesForFolder`; // 查看所有的service GET
// export const ADMIN_CHANGE_GROUP_URL = `/api/admin/assignService`;
// cms管理模块
export const ADMIN_SOURCE_URL = `/api/admin/source`; // post 添加新闻源
export const UPDATE_ADMIN_SOURCE_URL = `/api/admin/updateSource`; // post 添加新闻源
export const REMOVE_ADMIN_SOURCE_URL = `/api/admin/removeSource`; // post 添加新闻源
// 部门信息管理模块
export const ADMIN_DEPT_URL = `/api/admin/department`;
export const UPDATE_ADMIN_DEPT_URL = `/api/admin/updateDepartment`;
export const REMOVE_ADMIN_DEPT_URL = `/api/admin/removeDepartment`;
// 用户管理模块
export const ADMIN_USER_URL = `/api/admin/user`;
export const ADMIN_CHANGE_USER_ROLE_URL = `/api/admin/changeRole`;

// 管理pc的接口
export const ADMIN_SERVICE_PC_URL = `/api/admin/pc/service`;
export const REMOVE_ADMIN_SERVICE_PC_URL = `/api/admin/pc/removeService`;
export const UPDATE_ADMIN_SERVICE_PC_URL = `/api/admin/pc/updateService`;

export const ADMIN_FOLDER_SERVICE_PC_URL = `/api/admin/pc/services`; //应用聚合类型的查询

export const SERVICE_GROUP_PC_URL = `/api/admin/pc/serviceGroup`; //POST 用于 service_group操作
export const REMOVE_SERVICE_GROUP_PC_URL = `/api/admin/pc/removeServiceGroup`; //POST 用于 service_group操作
export const UPDATE_SERVICE_GROUP_PC_URL = `/api/admin/pc/updateServiceGroup`; //更新 用于 service_group操作

export const SORT_SERVICE_GROUP_PC_URL = `/api/admin/pc/sortServiceGroups`; //用于 排序service_group操作
export const SORT_SERVICE_PC_URL = `/api/admin/pc/reorderServices`; //用于 排序group中的应用
export const SERVICE_INGROUP_PC_URL = `/api/admin/pc/serviceInGroup`;
export const VALID_SERVICES_FOR_FOLDER_PC_URL = `/api/admin/pc/validServicesForFolder`; // 查看所有的service GET

// 用户操作记录
export const USER_LOGIN_URL = `/api/admin/record/login`;
export const USER_ADMIN_OPERATION_URL = `/api/admin/record/admin`;

export const ADMIN_CHANGE_PASSWORD_URL = "/auth/password";
